export type { EmailOtpConfirmationProps } from './email-otp-confirmation'
export {
  EmailOtpConfirmation,
  OTP_LENGTH,
  RESEND_COUNTDOWN_SECONDS,
} from './email-otp-confirmation'
